import {
  CPropertyListFilter,
  CPropertyListFilterKeys
} from "../util/propertyListFilter";
import { useFormContext, useWatch } from "react-hook-form";
import MxListContentSection from "@rf-l1/page/list/MxListContentSection";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import MxFormL3RushSwitchField from "@rf-l3/form/MxFormL3RushSwitchField";
import MxFormL3CityField from "@rf-l3/form/MxFormL3CityField";
import MxFormL3SelectSectorField from "@rf-l3/form/MxForml3Sectors";
import MxFormL3TextThousandField from "@rf-l3/form/MxFormL3TextThousandField";
import MxFormL3CheckField from "@rf-l3/form/MxFormL3CheckBoxField";
import MxItemsSectorWithCity from "@rf-l1/items-autocomplete/MxItemsSectorWithCity";
import { A_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import { A_PROPERTY_ORDER_BY } from "@/src-refactor/modules/shared/model/const/property-order-by.conts";
import {
  A_PROPERTY_TYPES_FOR_PROJECT,
  A_REALESTATE_TYPES,
  C_REALESTATE_TYPES,
  IRealestateType
} from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { A_PROPERTIES_STATUS_ARRAY } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { IconSearch } from "@tabler/icons-react";
import MxTypography from "@rf-l1/MxTypography";
import { useMemo, useState, useCallback, memo } from "react";
import { useLazyGetDetailPropertyQuery } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import MxInputField from "@rf-l1/form/text-fields/MxInputField";
import { debounce } from "lodash";
import MxLoading from "@rf-l1/loading/MxLoading";
import { useNavigate } from "react-router-dom";
import { QueryStatus } from "@reduxjs/toolkit/query";
import { PropertyListButtonFilters } from "./PropertyListButtonFilters";
import countFormat from "@rf-helper/format/count-format";
import useFormWatch from "@rf-hooks/useFormWatch";
import HCheckArray from "@rf-helper/check-have-value";
import useAlert from "@rf-hooks/useAlert";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import { useStatsSlice } from "@/src-refactor/modules/store/redux/stats/stats.slice";

interface PropertyMainFiltersProps {
  total: number;
  onResetMap?: () => void;
}

const PropertyMainFilters = memo(
  ({ total, onResetMap }: PropertyMainFiltersProps) => {
    const { reset } = useFormContext();
    const [searchResetKey, setSearchResetKey] = useState(0);

    const handleReset = useCallback(() => {
      // Reset all filters to defaults and force remount of search input
      reset(CPropertyListFilter);
      setSearchResetKey(prev => prev + 1);
      onResetMap?.();
    }, [reset, onResetMap]);

    return (
      <MxListContentSection
        container
        position="sticky"
        top={0}
        sx={{
          backgroundColor: "background.paper",
          zIndex: 1003
        }}
      >
        <StyledContent container wrap="nowrap" gap={1}>
          <FiltersContent container item wrap="wrap" alignItems="center" gap={1}>
            <Grid item width="100%" maxWidth={300} minWidth={200}>
              <SearchFilter key={`search-${searchResetKey}`} />
            </Grid>

            <Grid
              item
              width="100%"
              maxWidth={180}
              minWidth={160}
              display={{
                xs: "none",
                md: "block"
              }}
            >
              <RealEstateTypeFilter />
            </Grid>

            {/* <Grid
              item
              width="100%"
              maxWidth={140}
              minWidth={130}
              display={{
                xs: "none",
                md: "block"
              }}
            >
              <MxFormL3AutoComplete
                withreacthookform={1}
                name={CPropertyListFilterKeys.status}
                label="Estado"
                items={A_PROPERTIES_STATUS_ARRAY}
                isMultiple={true}
              />
            </Grid> */}
            <Grid
              item
              width="100%"
              maxWidth={360}
              minWidth={340}
              display={{
                xs: "none",
                lg: "block"
              }}
            >
              <CityAndSectorFormSection />
            </Grid>
            {/* <Grid
              item
              width="100%"
              maxWidth={400}
              minWidth={360}
              container
              spacing={1}
            > */}
            <Grid
              item
              width="100%"
              maxWidth={100}
              minWidth={80}
              display={{
                xs: "none",
                md: "block"
              }}
            >
              <CurrencyFilter />
            </Grid>

            <Grid
              item
              width="100%"
              maxWidth={120}
              minWidth={110}
              display={{
                xs: "none",
                md: "block"
              }}
            >
              <PriceMinFilter />
            </Grid>

            <Grid
              item
              width="100%"
              maxWidth={120}
              minWidth={110}
              display={{
                xs: "none",
                md: "block"
              }}
            >
              <PriceMaxFilter />
            </Grid>

            {/* </Grid> */}

            <Grid item xs="auto">
              <PropertyListButtonFilters />
            </Grid>

            <Grid
              item
              xs="auto"
              display={{
                xs: "none",
                lg: "block"
              }}
            >
              <MxButton2
                testId="reset-filters-button"
                textColor="error.main"
                children="Borrar filtros"
                onClick={handleReset}
                variant="text"
              />
            </Grid>
            <Grid
              item
              id="list-mode-toolbar"
              xs="auto"
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={1}
            />

            <Grid item id="toggle-map" />
          </FiltersContent>

          <ActionsContent container item direction="column">
            <Grid item xs="auto">
              <MyPropertiesFilter />
            </Grid>

            <Grid item>
              <DraftButton />
            </Grid>
          </ActionsContent>
        </StyledContent>
      </MxListContentSection>
    );
  }
);

PropertyMainFilters.displayName = "PropertyMainFilters";

const StyledContent = styled(Grid)(() => ({
  width: "100%",
  alignItems: "stretch"
}));

const FiltersContent = styled(Grid)(() => ({
  flex: "1",
  // maxWidth: "95%",
  width: "auto"
}));

const ActionsContent = styled(Grid)(({ theme }) => ({
  // flex: "0 ",
  width: "auto",
  minWidth: theme.spacing(6),
  alignSelf: "stretch",
  alignItems: "center",
  display: "flex",
  justifyContent: "space-around"
}));

const DraftButton = () => {
  const { stats } = useStatsSlice();
  const navigate = useNavigate();

  if (!Boolean(stats.countDrafts)) {
    return null;
  }
  return (
    <MxButton2
      textColor="primary.main"
      children="Borradores"
      onClick={() => navigate(C_PATH_ROUTES.REALESTATE.DRAFT_LIST)}
      variant="contained"
      fontWeight={600}
      bgColor={"grey.200"}
      sx={{
        borderRadius: 0.5
      }}
    />
  );
};

const SearchFilter = memo(() => {
  const [getDetailProperty, getDetailPropertyData] = useLazyGetDetailPropertyQuery();
  const { setValue } = useFormContext();
  const { infoAlert } = useAlert();

  const searchProperties = debounce(async (value: string) => {
    setValue(CPropertyListFilterKeys.search, value);
  }, 700);

  const handleInputChange = useCallback((value: string) => {
    if (value.length < 3 && value !== "") {
      return;
    }
    searchProperties(value);
  }, []);

  const handleNavigate = useCallback((id: string) => {
    window.open(`/realestates/detail/${id}`, "_blank");
  }, []);

  const handleEnter = useCallback(async (e: any) => {
    if (e.key === "Enter") {
      const isNumber = /^\d+$/.test(e.target?.value?.trim());
      if (!isNumber) {
        return;
      }
      searchProperties.cancel();
      const id = e.target.value.trim();
      await getDetailProperty({
        params: {
          id
        }
      })
        .unwrap()
        .then(res => {
          if (res.id) {
            handleNavigate(res.id.toString());
          }
        })
        .catch(e => {
          infoAlert({
            title: "Propiedad no encontrada",
            message: `No pudimos localizar una propiedad con el ID ${id}. Verifica que el número sea correcto e inténtalo de nuevo.`,
            confirmBtnMessage: "Entiendo"
          }).then(() => {
            // setValue(CPropertyListFilterKeys.search, "");
          });
          // console.log(e);
          // alert({
          //   title: "No se encontró la propiedad",
          //   message: `No se encontró la propiedad con el ID ${e.target.value.trim()}, verifica que el ID sea correcto`,
          //   color: "info.main",
          //   type: "info"
          // });
        });
    }
  }, []);

  const icon = useMemo(() => {
    if (getDetailPropertyData.status === QueryStatus.pending) {
      return <MxLoading size={16} />;
    }
    return <IconSearch />;
  }, [getDetailPropertyData.status]);

  return (
    <MxInputField
      placeholder="Buscar por nombre, código o descripción"
      onKeyDown={handleEnter}
      onSearch={handleInputChange}
      endIcon={icon}
    />
  );
});

const RealEstateTypeFilter = memo(() => {
  const { setValue } = useFormContext();
  const [isProject, setIsProject] = useState(false);
  const { type } = useFormWatch([CPropertyListFilterKeys.type]);

  const itemsProject = useMemo(() => {
    return [...A_PROPERTY_TYPES_FOR_PROJECT, C_REALESTATE_TYPES.PROJECT];
  }, []);

  const generateItems = useMemo(() => {
    if (HCheckArray(type)) {
      if (
        type.some(
          (item: IRealestateType) => item.value === C_REALESTATE_TYPES.PROJECT.value
        )
      ) {
        if (!isProject) {
          setTimeout(() => {
            setValue(CPropertyListFilterKeys.type, [C_REALESTATE_TYPES.PROJECT]);
            setIsProject(true);
          }, 200);
        }
        return itemsProject;
      }
      setIsProject(false);
      return A_REALESTATE_TYPES;
    }
    return A_REALESTATE_TYPES;
  }, [type]);

  return (
    <MxFormL3AutoComplete
      name={CPropertyListFilterKeys.type}
      label="Tipo de propiedad"
      items={generateItems}
      isMultiple={true}
      withreacthookform={1}
    />
  );
});

const CityAndSectorFormSection = memo(() => {
  const { setValue, control } = useFormContext();
  const cityField = useWatch({
    name: CPropertyListFilterKeys.city,
    defaultValue: [],
    control
  });

  const handleUpdateCity = useCallback(() => {
    setValue(CPropertyListFilterKeys.sector, []);
  }, [setValue]);

  const cityId = useMemo(() => {
    return HCheckArray(cityField) ? cityField[0].value : undefined;
  }, [cityField]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <MxFormL3CityField
          name={CPropertyListFilterKeys.city}
          label="Ciudad"
          withreacthookform={1}
          onSelect={handleUpdateCity}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MxFormL3SelectSectorField
          name={CPropertyListFilterKeys.sector}
          label="Sector"
          cityId={cityId}
          useCustomComponent={true}
          componentItem={MxItemsSectorWithCity}
          withreacthookform={1}
          isMultiple={true}
          disabled={!cityId}
        />
      </Grid>
    </Grid>
  );
});

const CurrencyFilter = memo(() => {
  return (
    <MxFormL3RushSwitchField
      withreacthookform={1}
      name={CPropertyListFilterKeys.currencySale}
      items={A_CURRENCY}
    />
  );
});

const PriceMinFilter = memo(() => {
  return (
    <MxFormL3TextThousandField
      withreacthookform={1}
      name={CPropertyListFilterKeys.priceMin}
      label="Precio mínimo"
    />
  );
});

const PriceMaxFilter = memo(() => {
  return (
    <MxFormL3TextThousandField
      withreacthookform={1}
      name={CPropertyListFilterKeys.priceMax}
      label="Precio máximo"
    />
  );
});

const MyPropertiesFilter = memo(() => {
  return (
    <MxFormL3CheckField
      positionlabel="right"
      withreacthookform={1}
      name={CPropertyListFilterKeys.myProperties}
      label="Mis propiedades"
    />
  );
});

SearchFilter.displayName = "SearchFilter";

export default PropertyMainFilters;
